module.exports = "<div class=\"sc-card-cell\" ng-style=\"{height: $ctrl.getHeight()}\"><div class=\"sc-card-cell-title\">{{$ctrl.filter.name}}</div><div class=\"sc-card-cell-form\"><div class=\"sc-card-cell-control\"><div>{{:: 'Ширина' | gettext}}</div><input type=\"number\" max=\"12\" min=\"1\" ng-model=\"$ctrl.filter.cardWidth\"></div><div class=\"sc-card-cell-control\"><div>{{:: 'Высота' | gettext}}</div><input type=\"number\" max=\"36\" min=\"0\" ng-model=\"$ctrl.filter.cardHeight\"></div></div></div>"


//////////////////
// WEBPACK FOOTER
// ./src/filter/editor/filter-card-editor-cell.component.html
// module id = 825
// module chunks = 0